import { Box, Button, Card, CardContent, CardHeader, Grid, List, ListItem, ListItemButton, ListItemText, Table, TableBody, TableCell, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTeam } from "../../master/team/team.api";
import { RootState } from "../../../store";
import { editPerformance, getDaySessionList, getPerformanceDetailSession } from "../dashboard.api";
import notificationSuccess from "../../../shared/notificationSuccess";
import notificationError from "../../../shared/notificationError";
import moment from "moment";

interface InterfaceValues {
    id: string;
    team_id: string;
    value_new: number;
    value_complete: number;
}

export default function DashboardPerformanceFormEdit(props: {
    onClose: (isReload: boolean) => void;
    date: string;
}) {

    const dispatch = useDispatch();

    const { daySessionList, performanceDetail } = useSelector((state: RootState) => state.dashboard);
    const { teamList } = useSelector((state: RootState) => state.team);

    const [values, setValues] = useState<InterfaceValues[]>([]);
    const [sessionSelected, setSessionSelected] = useState<string>("");

    useEffect(() => {
        dispatch<any>(getTeam());
        dispatch<any>(getDaySessionList(props.date));
    }, [dispatch, props.date]);

    useEffect(() => {
        if (daySessionList.length > 0 && sessionSelected === "") {
            setSessionSelected(daySessionList[0].ts_created);
        }
    }, [daySessionList, sessionSelected]);

    useEffect(() => {
        if (sessionSelected) {
            dispatch<any>(getPerformanceDetailSession(sessionSelected))
                .unwrap()
                .then((response: any) => {
                    if (response.status === 200) {
                        console.log(values)
                        setValues(response.data)
                    } else {
                        notificationError(response);
                    }
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionSelected, dispatch]);


    const getPerfValue = (teamName: string, key: string) => {
        const found = Array.isArray(performanceDetail) && performanceDetail.find((item: any) => item.team_name === teamName);
        return found ? found[key] : 0;
    };

    const handleChange = (team_id: string, field: keyof InterfaceValues, value: number) => {
        setValues((prevValues) =>
            prevValues.map((item) =>
                item.team_id === team_id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleSubmit = () => {
        dispatch<any>(editPerformance(values))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("success edit daily jobs")
                        .then(() => {
                            props.onClose(true)
                        })
                }
                else {
                    notificationError(response)
                }
            })
    };

    return (
        <Box px={2}>
            <Box zIndex={5} bgcolor={"white"} display="flex" justifyContent="space-between">
                <Typography variant="h5" >{props.date}</Typography>
                <Button variant="contained" onClick={handleSubmit}>Save</Button>
            </Box>
            <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                <Grid item xs={3}>
                    <List disablePadding>
                        {daySessionList.map((session: any, i: number) => (
                            <ListItem key={session.id} disablePadding>
                                <ListItemButton selected={sessionSelected === session.ts_created} onClick={() => setSessionSelected(session.ts_created)}>
                                    <ListItemText primary={`Input #${i + 1}`} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={9} sx={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}>
                    <Grid container spacing={2} sx={{ my: 1 }}>
                        {teamList.map((team: any) => (
                            <Grid item xs={6} key={team.id}>
                                <Card variant="outlined">
                                    <CardHeader title={team.name} />
                                    <CardContent>
                                        <Table size="small">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ border: 0 }}>New Today</TableCell>
                                                    <TableCell sx={{ border: 0 }}>:</TableCell>
                                                    <TableCell sx={{ border: 0 }}>
                                                        <TextField
                                                            variant="standard"
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            value={values.find((item) => item.team_id === team.id)?.value_new || 0}
                                                            onChange={(e) => handleChange(team.id, "value_new", Number(e.target.value))}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ border: 0 }}>Total New job</TableCell>
                                                    <TableCell sx={{ border: 0 }}>:</TableCell>
                                                    <TableCell sx={{ border: 0 }}>
                                                        <TextField
                                                            variant="standard"
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            value={getPerfValue(team.name, "value_new_week")}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ border: 0 }}>Complete today</TableCell>
                                                    <TableCell sx={{ border: 0 }}>:</TableCell>
                                                    <TableCell sx={{ border: 0 }}>
                                                        <TextField
                                                            variant="standard"
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            value={values.find((item) => item.team_id === team.id)?.value_complete || 0}
                                                            onChange={(e) => handleChange(team.id, "value_complete", Number(e.target.value))}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ border: 0 }}>Complete Weekly</TableCell>
                                                    <TableCell sx={{ border: 0 }}>:</TableCell>
                                                    <TableCell sx={{ border: 0 }}>
                                                        <TextField
                                                            variant="standard"
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            value={getPerfValue(team.name, "value_complete_week")}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}